<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="ratesLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
            show-expand
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Cenniki</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select v-model="selectedYear"  class="choose_year" :items="lookups.years" hide-details ></v-select>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchRates"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 


                <v-spacer></v-spacer>

                <v-dialog v-if="user.permissions['dictionary'] >= 20" v-model="dialogCopy" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" size="24" class="mr-2" color="primary" >mdi-content-copy</v-icon>
                  </template>
                  <copy-rates @close="closeCopy" :destination="selectedYear"></copy-rates>
                </v-dialog>

                <v-divider
                  v-if="user.permissions['dictionary'] >= 20"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['dictionary'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-dialog v-if="user.permissions['dictionary'] >= 10" v-model="dialog" max-width="1200px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="rateAddStatus===1 || rateEditLoadStatus===1 || rateEditStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                          <v-row>
                            <v-col class="col-5">
                              <v-card flat class="elevation-1 mb-8"  style="background-color: #f4f4f4;">
                                <v-toolbar flat  dense style="background-color: #f4f4f4;">
                                    <v-toolbar-title>Ustawienia</v-toolbar-title>
                                </v-toolbar>
                                <v-row class="pl-4 pr-4">
                                  <v-col class="col-12">
                                    <v-text-field hide-details="auto" v-model="editedItem.name" :error-messages="nameErrors" required @input="$v.editedItem.name.$touch()"  @blur="$v.editedItem.name.$touch()" counter="50" label="Nazwa"></v-text-field>
                                  </v-col>
                                  <v-col class="col-12">
                                    <v-select hide-details="auto" v-model="editedItem.category" :items="lookups.rate_categories" label="Grupa"></v-select>
                                    
                                  </v-col>
                                  <v-col class="col-6">
                                    <v-select hide-details="auto" clearable v-model="editedItem.free" :items="lookups.freeHours" label="Darmowe godziny"></v-select>
                                    
                                  </v-col>
                                  <v-col class="col-6">
                                    <v-select hide-details="auto" v-model="editedItem.tolerance" :items="lookups.tolerances" label="Tolerancja"></v-select>
                                    
                                  </v-col>
                                </v-row>
                                <v-row class="pl-4 pr-4" dense>
                                  <v-col class="col-12">
                                    <v-checkbox hide-details="auto" single-line v-model="editedItem.mealsFromJournal" label="Opłaty żywieniowe na podstawie obecności"></v-checkbox>
                                  </v-col> 
                                </v-row>
                                <v-row class="pl-4 pr-4 pb-2" dense>
                                  <v-col class="col-4"><v-checkbox single-line hide-details="auto" v-model="editedItem.hasBreakfast" label="Śniadanie"></v-checkbox></v-col>
                                  <v-col class="col-3"><v-checkbox single-line hide-details="auto" v-model="editedItem.hasLunch" label="Obiad"></v-checkbox></v-col>
                                  <v-col class="col-3"><v-checkbox single-line hide-details="auto" v-model="editedItem.hasTea" label="Podwieczorek"></v-checkbox></v-col> 
                                </v-row>
                              </v-card>

                              <v-card flat class="elevation-1"  style="background-color: #f4f4f4;">
                                <v-toolbar flat  dense style="background-color: #f4f4f4;">
                                    <v-toolbar-title>Opłaty miesięczne stałe</v-toolbar-title>
                                </v-toolbar>
                                <v-row class="pl-4 pr-4">
                                  <v-col class="col-6">
                                    <v-text-field v-model="editedItem.monthly" :error-messages="monthlyErrors" required @input="$v.editedItem.monthly.$touch()"  @blur="$v.editedItem.monthly.$touch()" label="Czesne"></v-text-field>
                                  </v-col>
                                  <v-col class="col-6">
                                    <v-text-field v-model="editedItem.monthlyNP" :error-messages="monthlyNPErrors" required @input="$v.editedItem.monthlyNP.$touch()"  @blur="$v.editedItem.monthlyNP.$touch()" label="Czesne nieobecne" persistent-hint hint="Dziecka nie ma cały miesiąc"></v-text-field>
                                  </v-col>
                                   <v-col class="col-6">
                                    <v-text-field v-model="editedItem.monthlyMeal" :error-messages="monthlyMealErrors" required @input="$v.editedItem.monthlyMeal.$touch()"  @blur="$v.editedItem.monthlyMeal.$touch()" label="Wyżywienie"></v-text-field>
                                  </v-col>
                                  <v-col class="col-6">
                                    <v-text-field v-model="editedItem.monthlyOther" :error-messages="monthlyOtherErrors" required @input="$v.editedItem.monthlyOther.$touch()"  @blur="$v.editedItem.monthlyOther.$touch()" label="Inne"></v-text-field>
                                  </v-col>
                                  
                                </v-row>
                              </v-card>
                            </v-col>

                            <v-col class="col-7">
                                 <v-card flat class="elevation-1"  style="background-color: #f4f4f4;">
                                <v-toolbar flat  dense style="background-color: #f4f4f4;">
                                    <v-toolbar-title>Opłaty zmienne</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    (D) - dniowe, (G) - godzinowe
                                </v-toolbar>
                                <v-row class="pl-4 pr-4">
                                  <v-col class="col-12">
                                    <h3>Dziecko obecne</h3>
                                  </v-col>
                                  <v-col class="col-4">
                                    <v-text-field v-model="editedItem.hour" :error-messages="hourErrors" required @input="$v.editedItem.hour.$touch()"  @blur="$v.editedItem.hour.$touch()" label="Pobyt(G)" persistent-hint hint="W godzinach pracy grupy"></v-text-field>
                                  </v-col>
                                  <v-col class="col-4" v-if="editedItem.hasBreakfast">
                                    <v-text-field v-model="editedItem.breakfast" :error-messages="breakfastErrors" required @input="$v.editedItem.breakfast.$touch()"  @blur="$v.editedItem.breakfast.$touch()" label="Śniadanie(D)"></v-text-field>
                                  </v-col>
                                  <v-col class="col-4" v-if="editedItem.hasLunch">
                                    <v-text-field v-model="editedItem.lunch" :error-messages="lunchErrors" required @input="$v.editedItem.lunch.$touch()"  @blur="$v.editedItem.lunch.$touch()" label="Obiad(D)"></v-text-field>
                                  </v-col>
                                  <v-col class="col-4" v-if="editedItem.hasTea"> 
                                    <v-text-field v-model="editedItem.tea" :error-messages="teaErrors" required @input="$v.editedItem.tea.$touch()"  @blur="$v.editedItem.tea.$touch()" label="Podwieczorek(D)"></v-text-field>
                                  </v-col>
                                  <v-col class="col-4">
                                    <v-text-field v-model="editedItem.other" :error-messages="otherErrors" required @input="$v.editedItem.other.$touch()"  @blur="$v.editedItem.other.$touch()" label="Inne(D)"></v-text-field>
                                  </v-col>
                                  <v-col class="col-4">
                                    <v-text-field v-model="editedItem.overtime" :error-messages="overtimeErrors" required @input="$v.editedItem.overtime.$touch()"  @blur="$v.editedItem.overtime.$touch()" label="Nadgodziny(G)" persistent-hint hint="Poza godzinami pracy grupy"></v-text-field>
                                  </v-col>
                                  <v-col class="col-12">
                                    <h3>Dziecko nieobecne</h3>
                                  </v-col>
                                  <v-col class="col-4">
                                    <v-text-field v-model="editedItem.hourNP" :error-messages="hourNPErrors" required @input="$v.editedItem.hourNP.$touch()"  @blur="$v.editedItem.hourNP.$touch()" label="Pobyt(G)"></v-text-field>
                                  </v-col>
                                  <v-col class="col-4" v-if="editedItem.hasBreakfast">
                                    <v-text-field v-model="editedItem.breakfastNP" :error-messages="breakfastNPErrors" required @input="$v.editedItem.breakfastNP.$touch()"  @blur="$v.editedItem.breakfastNP.$touch()" label="Śniadanie(D)"></v-text-field>
                                  </v-col>
                                  <v-col class="col-4" v-if="editedItem.hasLunch">
                                    <v-text-field v-model="editedItem.lunchNP" :error-messages="lunchNPErrors" required @input="$v.editedItem.lunchNP.$touch()"  @blur="$v.editedItem.lunchNP.$touch()" label="Obiad(D)"></v-text-field>
                                  </v-col>
                                  <v-col class="col-4" v-if="editedItem.hasTea">
                                    <v-text-field v-model="editedItem.teaNP" :error-messages="teaNPErrors" required @input="$v.editedItem.teaNP.$touch()"  @blur="$v.editedItem.teaNP.$touch()" label="Podwieczorek(D)"></v-text-field>
                                  </v-col>
                                  <v-col class="col-4">
                                    <v-text-field v-model="editedItem.otherNP" :error-messages="otherNPErrors" required @input="$v.editedItem.otherNP.$touch()"  @blur="$v.editedItem.otherNP.$touch()" label="Inne(D)"></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Zapisz</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item.monthly="{ item }">
              {{ $n(item.monthly+item.monthlyMeal+item.monthlyOther, 'currency', 'pl-PL') }}
            </template>
            
            <template v-slot:item.overtime="{ item }">
              {{ $n(item.overtime, 'currency', 'pl-PL') }}
            </template>

            <template v-slot:item.hour="{ item }">
              {{ $n(item.hour, 'currency', 'pl-PL') }} / {{ $n(item.hourNP, 'currency', 'pl-PL') }}
            </template>

            <template v-slot:item.breakfast="{ item }">
              <div v-if="item.hasBreakfast">
                {{ $n(item.breakfast, 'currency', 'pl-PL') }} / {{ $n(item.breakfastNP, 'currency', 'pl-PL') }}
              </div>
            </template>

            <template v-slot:item.lunch="{ item }">
              <div v-if="item.hasLunch">
              {{ $n(item.lunch, 'currency', 'pl-PL') }} / {{ $n(item.lunchNP, 'currency', 'pl-PL') }}
              </div>
            </template>

            <template v-slot:item.tea="{ item }">
              <div v-if="item.hasTea">
              {{ $n(item.tea, 'currency', 'pl-PL') }} / {{ $n(item.teaNP, 'currency', 'pl-PL') }}
              </div>
            </template>

            <template v-slot:item.other="{ item }">
              {{ $n(item.other, 'currency', 'pl-PL') }} / {{ $n(item.otherNP, 'currency', 'pl-PL') }}
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip v-if="item.status && user.permissions['dictionary'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.status && item.can_delete && user.permissions['dictionary'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status  && user.permissions['dictionary'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="reactivateItem(item)"
                  >
                    mdi-delete-restore
                  </v-icon>
                  </template>
                  <span>Przywróć</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status && item.can_delete  && user.permissions['dictionary'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    color="error"
                    @click="forceDeleteItem(item)"
                  >
                    mdi-delete-forever
                  </v-icon>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>

                
            </template> 

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.status" disabled></v-simple-checkbox>
            </template>



            <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
              <v-icon
                v-if="item.archives.length>0"
                :class="['v-data-table__expand-icon', { 'v-data-table__expand-icon--active': isExpanded }]"
                @click.stop="expand(!isExpanded)"
              >$expand</v-icon>
            </template>
            

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pl-5 pr-5 pt-5 pb-5">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Od</th>
                          <th>Do</th>
                          <th v-for="h in headers.filter(h => h.value!=='lp' && h.value!=='status' && h.value!=='actions' && h.value!=='data-table-expand')" :key="h.value">{{h.text}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="i in item.archives" :key="i.id">
                          <td>{{i.started_at}}</td>
                          <td>{{i.ended_at}}</td>
                          <td>{{i.name}}</td>
                          <td>{{i.free}}</td>
                          <td>{{ $n(i.monthly+i.monthlyMeal+i.monthlyOther, 'currency', 'pl-PL') }}</td>
                          <td>{{ $n(i.overtime, 'currency', 'pl-PL') }}</td>
                          <td>{{ $n(i.hour, 'currency', 'pl-PL') }} / {{ $n(i.hourNP, 'currency', 'pl-PL') }}</td>
                          <td><div v-if="i.hasBreakfast">{{ $n(i.breakfast, 'currency', 'pl-PL') }} / {{ $n(i.breakfastNP, 'currency', 'pl-PL') }}</div></td>
                          <td><div v-if="i.hasLunch">{{ $n(i.lunch, 'currency', 'pl-PL') }} / {{ $n(i.lunchNP, 'currency', 'pl-PL') }}</div></td>
                          <td><div v-if="i.hasTea">{{ $n(i.tea, 'currency', 'pl-PL') }} / {{ $n(i.teaNP, 'currency', 'pl-PL') }}</div></td>
                          <td>{{ $n(i.other, 'currency', 'pl-PL') }} / {{ $n(i.otherNP, 'currency', 'pl-PL') }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>


              </td>
            </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && ratesLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadRates" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadRates" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import confirm from '../components/Confirm'
  import maxLength from 'vuelidate/lib/validators/maxLength'
  import required from 'vuelidate/lib/validators/required'
  import decimal from 'vuelidate/lib/validators/decimal'
  import CopyRates from "../components/CopyRates"
  import { helpers } from 'vuelidate/lib/validators'
  const decimalPL = helpers.regex('decimalPL', /^[-]?\d*(\,\d+)?$/)

  export default {
    components:{
      confirm,
      CopyRates
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      menuOd: false,
      menuDo: false,
      //selectedYear:0,
      dialog: false,
      dialogCopy:false,
      itemEditing:false,
      search:'',
      itemWasDefault:false,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false},
        { text: 'Nazwa', value: 'name',filterable:true },
        { text: 'Darmowe', value: 'free',filterable:true },
        { text: 'Stała(M)', value: 'monthly',filterable:true },
        { text: 'Nadgodziny(G)', value: 'overtime',filterable:true },
        { text: 'Pobyt(G)', value: 'hour',filterable:true },
        { text: 'Śniadanie(D)', value: 'breakfast',filterable:true },
        { text: 'Obiad(D)', value: 'lunch',filterable:true },
        { text: 'Podwieczorek(D)', value: 'tea',filterable:true },
        { text: 'Inne(D)', value: 'other',filterable:true },
        { text: 'Status', value: 'status',filterable:false },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false },
        { text: '',value:'data-table-expand',sortable: false}
      ],
    }),
    validations: {
      editedItem:{
        name: {
          required,
          maxLength:maxLength(50),
        },
        monthly:{
          required,
          decimalPL
        },
        monthlyNP:{
          required,
          decimalPL
        },
        monthlyMeal:{
          required,
          decimalPL
        },
        monthlyOther:{
          required,
          decimalPL
        },
        hour:{
          required,
          decimalPL
        },
        overtime:{
          required,
          decimalPL
        },
        breakfast:{
          required,
          decimalPL
        },
        lunch:{
          required,
          decimalPL
        },
        tea:{
          required,
          decimalPL
        },
        other:{
          required,
          decimalPL
        },
        hourNP:{
          required,
          decimalPL
        },
        breakfastNP:{
          required,
          decimalPL
        },
        lunchNP:{
          required,
          decimalPL
        },
        teaNP:{
          required,
          decimalPL
        },
        otherNP:{
          required,
          decimalPL
        },
      }
    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    
      dialog (val) {
        this.$v.$reset()
        val || this.close()
      },
      rateEditStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      rateAddStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      rateDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getRateOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setRateOptions', {options:value} )
        }
      },
      selectedYear:{
        get () {
          return this.$store.getters.getRateOptions.selectedYear;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedYear = value;
          this.options = currentOptions;
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getRateOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getRateEdit;
      },
      tableItems(){
        return this.$store.getters.getRates;
      },
      ratesLoadStatus(){
        return this.$store.getters.getRatesLoadStatus;
      },
      rateEditLoadStatus(){
        return this.$store.getters.getRateEditLoadStatus
      },
      rateEditStatus(){
        return this.$store.getters.getRateEditStatus();
      },
      rateEditText(){
        return this.$store.getters.getRateEditText
      },
      rateAddStatus(){
        return this.$store.getters.getRateAddStatus();
      },
      rateAddText(){
        return this.$store.getters.getRateAddText;
      },
      rateDeleteStatus(){
        return this.$store.getters.getRateDeleteStatus();
      },
      computedHeaders () {
        if(!this.showDeleted && this.user.permissions['dictionary'] <= 5) return this.headers.filter(h => h.value!=='status' && h.value!=='actions')
        else if(this.showDeleted && this.user.permissions['dictionary'] <= 5) return this.headers.filter(h => h.value!=='actions')
        else if(!this.showDeleted) return this.headers.filter(h => h.value!=='status')
        else return this.headers
      },
      formTitle () {
        return !this.itemEditing ? 'Nowy cennik' : 'Edycja cennika'
      },
      nameErrors () {
        const errors = []
        if (!this.$v.editedItem.name.$dirty) return errors
        !this.$v.editedItem.name.required && errors.push('Nazwa jest wymagana')
        !this.$v.editedItem.name.maxLength && errors.push('Nazwa może mieć maksymalnie 50 znaków')
        return errors
      },
      monthlyErrors () {
        const errors = []
        if (!this.$v.editedItem.monthly.$dirty) return errors
        !this.$v.editedItem.monthly.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.monthly.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      monthlyNPErrors () {
        const errors = []
        if (!this.$v.editedItem.monthlyNP.$dirty) return errors
        !this.$v.editedItem.monthlyNP.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.monthlyNP.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      monthlyMealErrors () {
        const errors = []
        if (!this.$v.editedItem.monthlyMeal.$dirty) return errors
        !this.$v.editedItem.monthlyMeal.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.monthlyMeal.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      monthlyOtherErrors () {
        const errors = []
        if (!this.$v.editedItem.monthlyOther.$dirty) return errors
        !this.$v.editedItem.monthlyOther.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.monthlyOther.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      hourErrors () {
        const errors = []
        if (!this.$v.editedItem.hour.$dirty) return errors
        !this.$v.editedItem.hour.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.hour.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      overtimeErrors () {
        const errors = []
        if (!this.$v.editedItem.overtime.$dirty) return errors
        !this.$v.editedItem.overtime.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.overtime.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      breakfastErrors () {
        const errors = []
        if (!this.$v.editedItem.breakfast.$dirty) return errors
        !this.$v.editedItem.breakfast.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.breakfast.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      lunchErrors () {
        const errors = []
        if (!this.$v.editedItem.lunch.$dirty) return errors
        !this.$v.editedItem.lunch.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.lunch.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      teaErrors () {
        const errors = []
        if (!this.$v.editedItem.tea.$dirty) return errors
        !this.$v.editedItem.tea.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.tea.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      otherErrors () {
        const errors = []
        if (!this.$v.editedItem.other.$dirty) return errors
        !this.$v.editedItem.other.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      hourNPErrors () {
        const errors = []
        if (!this.$v.editedItem.hourNP.$dirty) return errors
        !this.$v.editedItem.hourNP.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.hourNP.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      breakfastNPErrors () {
        const errors = []
        if (!this.$v.editedItem.breakfastNP.$dirty) return errors
        !this.$v.editedItem.breakfastNP.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.breakfastNP.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      lunchNPErrors () {
        const errors = []
        if (!this.$v.editedItem.lunchNP.$dirty) return errors
        !this.$v.editedItem.lunchNP.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.lunchNP.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      teaNPErrors () {
        const errors = []
        if (!this.$v.editedItem.teaNP.$dirty) return errors
        !this.$v.editedItem.teaNP.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.teaNP.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      otherNPErrors () {
        const errors = []
        if (!this.$v.editedItem.otherNP.$dirty) return errors
        !this.$v.editedItem.otherNP.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.otherNP.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
     
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadRates();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadRates();
        }, 2000)
      }
    },
    methods: {
      loadRates(){
        this.search='';
        this.$store.dispatch( 'loadRates' );
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreRates' );
      },
      reactivateItem(item){
        this.$store.dispatch( 'editRateReactivate',{slug:item.id});
      },
      editItem (item) {
        this.itemWasMain = item.main;
        this.itemEditing = true
        this.$store.dispatch( 'loadRateEdit', {slug:  item.id});  
        this.dialog = true
      },
      deleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz wyłączyć rok szkolny?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteRate', {slug:  item.id});
            }
        })
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać rok szkolny na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteRate', {slug:  item.id});
            }
        })
      },
      searchRates(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'value'),';');
          this.$store.dispatch( 'searchRates',{filterableHeaders:filterableHeaders,q:this.search.replace(/,/, ".")});
        }
      },
      close () {
        this.dialog = false
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadRateEditDefault'); 
          this.$store.dispatch( 'loadRateAddDefault');
          this.itemEditing = false
        }, 300)
      },
      closeCopy(){
        this.dialogCopy = false
        this.$v.$reset()
      },
      handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
         
            if (this.itemEditing) {
              //edycja
              this.$store.dispatch( 'editRate', {
                slug: this.editedItem.id,
                name:  this.editedItem.name,
                category:  this.editedItem.category,
                free:  this.editedItem.free,
                tolerance: this.editedItem.tolerance,
                mealsFromJournal: this.editedItem.mealsFromJournal,
                hasBreakfast: this.editedItem.hasBreakfast,
                hasLunch: this.editedItem.hasLunch,
                hasTea: this.editedItem.hasTea,
                year_id: this.editedItem.year_id,
                monthly: this.editedItem.monthly.toString().replace(/\./g, "").replace(/,/, "."),
                monthlyNP: this.editedItem.monthlyNP.toString().replace(/\./g, "").replace(/,/, "."),
                monthlyMeal: this.editedItem.monthlyMeal.toString().replace(/\./g, "").replace(/,/, "."),
                monthlyOther: this.editedItem.monthlyOther.toString().replace(/\./g, "").replace(/,/, "."),
                hour: this.editedItem.hour.toString().replace(/\./g, "").replace(/,/, "."),
                overtime: this.editedItem.overtime.toString().replace(/\./g, "").replace(/,/, "."),
                breakfast: this.editedItem.hasBreakfast?this.editedItem.breakfast.toString().replace(/\./g, "").replace(/,/, "."):0,
                lunch: this.editedItem.hasLunch?this.editedItem.lunch.toString().replace(/\./g, "").replace(/,/, "."):0,
                tea: this.editedItem.hasTea?this.editedItem.tea.toString().replace(/\./g, "").replace(/,/, "."):0,
                other: this.editedItem.other.toString().replace(/\./g, "").replace(/,/, "."),
                hourNP: this.editedItem.hourNP.toString().replace(/\./g, "").replace(/,/, "."),
                breakfastNP: this.editedItem.hasBreakfast?this.editedItem.breakfastNP.toString().replace(/\./g, "").replace(/,/, "."):0,
                lunchNP: this.editedItem.hasLunch?this.editedItem.lunchNP.toString().replace(/\./g, "").replace(/,/, "."):0,
                teaNP: this.editedItem.hasTea?this.editedItem.teaNP.toString().replace(/\./g, "").replace(/,/, "."):0,
                otherNP: this.editedItem.otherNP.toString().replace(/\./g, "").replace(/,/, ".") 
              });
            } else {//new item
              this.$store.dispatch( 'addRate', {
                name:  this.editedItem.name,
                category:  this.editedItem.category,
                free:  this.editedItem.free,
                tolerance: this.editedItem.tolerance,
                mealsFromJournal: this.editedItem.mealsFromJournal,
                hasBreakfast: this.editedItem.hasBreakfast,
                hasLunch: this.editedItem.hasLunch,
                hasTea: this.editedItem.hasTea,
                year_id: this.editedItem.year_id,
                monthly: this.editedItem.monthly.toString().replace(/\./g, "").replace(/,/, "."),
                monthlyNP: this.editedItem.monthlyNP.toString().replace(/\./g, "").replace(/,/, "."),
                monthlyMeal: this.editedItem.monthlyMeal.toString().replace(/\./g, "").replace(/,/, "."),
                monthlyOther: this.editedItem.monthlyOther.toString().replace(/\./g, "").replace(/,/, "."),
                hour: this.editedItem.hour.toString().replace(/\./g, "").replace(/,/, "."),
                overtime: this.editedItem.overtime.toString().replace(/\./g, "").replace(/,/, "."),
                breakfast: this.editedItem.hasBreakfast?this.editedItem.breakfast.toString().replace(/\./g, "").replace(/,/, "."):0,
                lunch: this.editedItem.hasLunch?this.editedItem.lunch.toString().replace(/\./g, "").replace(/,/, "."):0,
                tea: this.editedItem.hasTea?this.editedItem.tea.toString().replace(/\./g, "").replace(/,/, "."):0,
                other: this.editedItem.other.toString().replace(/\./g, "").replace(/,/, "."),
                hourNP: this.editedItem.hourNP.toString().replace(/\./g, "").replace(/,/, "."),
                breakfastNP: this.editedItem.hasBreakfast?this.editedItem.breakfastNP.toString().replace(/\./g, "").replace(/,/, "."):0,
                lunchNP: this.editedItem.hasLunch?this.editedItem.lunchNP.toString().replace(/\./g, "").replace(/,/, "."):0,
                teaNP: this.editedItem.hasTea?this.editedItem.teaNP.toString().replace(/\./g, "").replace(/,/, "."):0,
                otherNP: this.editedItem.otherNP.toString().replace(/\./g, "").replace(/,/, ".") 
              });

            }
        }
      },
    },
  }
</script>


<style scoped>
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 150px;
}
</style>